module.exports = __webpack_public_path__ + "static/img/8.991c261.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/zh/8.png
// module id = hFpr
// module chunks = 0